var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesMarketplace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h88v88H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.397 35.165v36.204a4 4 0 0 0 4 4H69.59a4 4 0 0 0 4-4V35.163",
    fill: "#6173FE"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#7EB2EA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.794 37.8A7.398 7.398 0 0 1 7 37.8h14.794zm59.194 0a7.398 7.398 0 0 1-14.794 0h14.794zM24.954 13 7 37.8h14.8L32.652 13h-7.085c-.376 0-.712.172-.933.443l.32-.443M40.35 13 36.6 37.8h14.8L48.048 13H40.35M62.829 13h-7.083L66.2 37.8H81L63.737 13.414A1.202 1.202 0 0 0 62.83 13M51.394 37.8a7.398 7.398 0 0 1-14.794 0h14.794"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC727",
    d: "M32.652 13 21.8 37.8h14.8L40.35 13h-7.698M48.048 13 51.4 37.8h14.8L55.746 13h-7.698M36.594 37.8a7.398 7.398 0 0 1-14.794 0h14.794M66.188 37.8a7.398 7.398 0 0 1-14.794 0h14.794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.666 48.02h5.13c1.782 0 2.429.186 3.08.534.652.349 1.164.86 1.513 1.512.348.652.534 1.299.534 3.082v22.2H18.538v-22.2c0-1.783.186-2.43.535-3.082a3.635 3.635 0 0 1 1.512-1.512c.652-.348 1.298-.534 3.081-.534zM42.897 48.02h21.728c1.783 0 2.43.186 3.081.534.652.349 1.164.86 1.512 1.512.349.652.535 1.299.535 3.082v13.226c0 1.783-.186 2.43-.535 3.081a3.635 3.635 0 0 1-1.512 1.512c-.652.349-1.298.535-3.081.535H42.897c-1.783 0-2.43-.186-3.082-.535a3.635 3.635 0 0 1-1.512-1.512c-.348-.652-.534-1.298-.534-3.081V53.148c0-1.783.186-2.43.534-3.082a3.635 3.635 0 0 1 1.512-1.512c.652-.348 1.299-.534 3.082-.534z",
    fill: "#EBECFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesMarketplace);
export default __webpack_public_path__ + "static/media/features-marketplace.a30985d8.svg";
export { ForwardRef as ReactComponent };